import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';

/**
 * Raíz de la aplicación: solo monta el router-outlet.
 *
 * El sidebar y la sesión se resuelven por rutas anidadas (ver app.routes.ts):
 *   - Todo lo que cuelga de LayoutComponent tiene sidebar.
 *   - La ruta '/' (login) queda fuera del layout.
 */
@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  title = 'epione-medtronic-surgical';
}
